import { render, staticRenderFns } from "./list.item.vue?vue&type=template&id=4c9c64b6&"
import script from "./list.item.vue?vue&type=script&lang=js&"
export * from "./list.item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports